export default "__VITE_ASSET__2a60b368__"